import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "hamburger-menu__main-section-wrapper" }
const _hoisted_2 = {
  width: "23",
  height: "23",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = {
  key: 0,
  d: "M12 5V19",
  stroke: "#333333",
  "stroke-width": "1.25",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5 12H19",
  stroke: "#333333",
  "stroke-width": "1.25",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "hamburger-menu__child-links-container"
}
const _hoisted_6 = {
  key: 0,
  class: "hamburger-menu__child-promotions"
}

import {
  ref, computed,
} from 'vue';

import HamburgerMenuSection from './HamburgerMenuSection.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HamburgerMenuMain',
  props: {
  menuItem: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props



const isOpen = ref(false);
const promotions = computed(() => props.menuItem.blocks.Promotions);

function toggle() {
  isOpen.value = !isOpen.value;
}

const sections = computed(() => {
  return props.menuItem.sections.reduce((acc, s) => {
    if (s && s.id && !s.featured) {
      const itemsWithUrl = s.items.filter(i => i.url);
      acc.push({ ...s, items: itemsWithUrl });
    }

    return acc;
  }, []);
});
const featuredSections = computed(() => {
  return props.menuItem.sections.reduce((acc, s) => {
    if (s && s.id && s.featured) {
      const itemsWithUrl = s.items.filter(i => i.url);
      acc.push({ ...s, items: itemsWithUrl });
    }

    return acc;
  }, []);
});


return (_ctx: any,_cache: any) => {
  const _component_blocks_repeater = _resolveComponent("blocks-repeater")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: toggle,
      class: "hamburger-menu__main-section clean-button"
    }, [
      _createTextVNode(_toDisplayString(__props.menuItem.label) + " ", 1),
      (_openBlock(), _createElementBlock("svg", _hoisted_2, [
        (!isOpen.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_3))
          : _createCommentVNode("", true),
        _hoisted_4
      ]))
    ]),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(featuredSections), (section) => {
            return (_openBlock(), _createBlock(HamburgerMenuSection, {
              key: section.id,
              featured: true,
              menuSection: section
            }, null, 8, ["menuSection"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sections), (section) => {
            return (_openBlock(), _createBlock(HamburgerMenuSection, {
              key: section.id,
              menuSection: section
            }, null, 8, ["menuSection"]))
          }), 128)),
          (_unref(promotions))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_blocks_repeater, { blocks: _unref(promotions) }, null, 8, ["blocks"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})